import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "slick-carousel/slick/slick.css";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick-theme.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

import RouterContainer from "./RouterContainer";
import { DataProvider } from "./DataContext";
// import LanguageTranslator from "./LanguageTranslator";

function App() {
  return (
    <DataProvider>
      <div>
        <RouterContainer />
        {/* <LanguageTranslator /> */}
      </div>
    </DataProvider>
  );
}

export default App;
